import { isObject } from 'lodash'
import type { FieldValues } from 'react-hook-form'

/** When we have controlled fields that defaults to an empty string, we would prefer to not submit that empty string.
 * This function deeply traverses all the values of the provided fields and checks if it is an empty string.
 * If it is an empty string it will be set to undefined and will otherwise return its original value. */
export const sanitizeFields = <T extends FieldValues>(fields: T): FieldValues =>
	Object.fromEntries(
		Object.entries(fields).map(([key, value]) => {
			if (value === '') return [key, undefined]
			if (isObject(value) && !Array.isArray(value)) return [key, sanitizeFields(value)]
			return [key, value]
		}),
	)
